export const formatCurrencyPDF = (value) => {
  return value
    .toFixed(0) // Limita a 2 decimales
    .replace(".", ",") // Cambia el punto decimal por una coma
    .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Agrega puntos como separador de miles
};
